import { Flex, Icon, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'

import { PricingTable } from './pricingTable/PricingTable'
import { useState } from 'src/hooks'
import {
  PlanTiles,
  PlanTilesProps,
} from 'src/pricing_page/components/pricingTile/PlanTiles'

type TableProps = {
  title: string
}
type PlanTileType = Omit<PlanTilesProps, 'planIds'>
type PricingPageProps = {
  pricingTile: PlanTileType
  comparisonTable: TableProps
}

export const PricingPage = (props: PricingPageProps) => {
  const { pricingTile, comparisonTable } = props

  const [shouldShowTable, setShouldShowTable] = useState(false)

  return (
    <Flex
      width="100%"
      flexDirection="column"
      rowGap="16px"
      inset="x1"
      style={{ transform: 'scale(.85,.78)' }}
    >
      {!shouldShowTable && (
        <>
          <PlanTiles
            title={pricingTile.title}
            description={pricingTile.description}
            planIds={[{ id: '1' }, { id: '6' }, { id: '128' }, { id: '129' }]}
            onSelect={pricingTile.onSelect}
            carouselGap={{ mobileGap: 16, tabletGap: 16, desktopGap: 16 }}
          />
        </>
      )}
      {shouldShowTable && (
        <>
          <Flex
            onClick={() => setShouldShowTable(false)}
            width="100%"
            flexDirection="row"
            alignItems="center"
            cursor="pointer"
          >
            <Icon
              name="leftChevron"
              size="xSmall"
              primaryColor="primaryBodyText"
            />
            <Text
              content="Go back"
              type="body"
              style={{ fontSize: '.75rem', fontWeight: 700 }}
            />
          </Flex>
          <Text
            type="body"
            content={comparisonTable.title}
            color="primaryHeading"
            style={{ fontSize: '1.5rem', fontWeight: 700 }}
            alignment="center"
            inset={{ top: 'x2', bottom: 'x4' }}
          />
          <PricingTable />
        </>
      )}
    </Flex>
  )
}
